"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
exports.is = {
    arr: Array.isArray,
    obj: function (a) {
        return !!a && a.constructor.name === 'Object';
    },
    fun: function (a) { return typeof a === 'function'; },
    str: function (a) { return typeof a === 'string'; },
    num: function (a) { return typeof a === 'number'; },
    und: function (a) { return a === void 0; },
};
/** An unsafe object/array/set iterator that allows for better minification */
exports.each = function (obj, cb, ctx) {
    if (exports.is.fun(obj.forEach)) {
        obj.forEach(cb, ctx);
    }
    else {
        Object.keys(obj).forEach(function (key) { return cb.call(ctx, obj[key], key); });
    }
};
exports.toArray = function (a) {
    return exports.is.und(a) ? [] : Array.isArray(a) ? a : [a];
};
exports.useOnce = function (effect) { return react_1.useEffect(effect, []); };
exports.useForceUpdate = function () { return react_1.useReducer(function () { return ({}); }, 0)[1]; };
/** Use a value from the previous render */
function usePrev(value) {
    var prevRef = react_1.useRef(undefined);
    react_1.useEffect(function () {
        prevRef.current = value;
    });
    return prevRef.current;
}
exports.usePrev = usePrev;
//# sourceMappingURL=helpers.js.map